import { css } from "@stubhub/broadway-foundation/css";

export const promoBannerSkeleton = css({
  width: "full",
  minHeight: "[160px]",
  backgroundColor: "[var(--bway-colors-bg-surface-stronger)]",
  backgroundImage:
    "[linear-gradient(135deg,var(--bway-colors-bg-surface-stronger) 25%,var(--bway-colors-bg-surface-strong) 50%,var(--bway-colors-bg-surface-stronger) 75%)]",
  backgroundSize: "[200% 200%]",
  animationName: "[shimmer]",
  animationDuration: "[1.5s]",
  animationTimingFunction: "[linear]",
  animationIterationCount: "[infinite]",
  borderStartStartRadius: "primitives.50",
  borderStartEndRadius: "primitives.50",
  borderEndStartRadius: "primitives.50",
  borderEndEndRadius: "primitives.50",
  tablet: {
    minHeight: "[97px]",
  },
});
